export function getNogaItems(translate) {
  const items = [
    { id: 711101, value: translate("benchmarking.evaluations.filters.noga.arch"), label: translate("benchmarking.evaluations.filters.noga.arch") },
    { id: 711102, value: translate("benchmarking.evaluations.filters.noga.sppl"), label: translate("benchmarking.evaluations.filters.noga.sppl") },
    { id: 711103, value: translate("benchmarking.evaluations.filters.noga.laar"), label: translate("benchmarking.evaluations.filters.noga.laar") },
    { id: 711201, value: translate("benchmarking.evaluations.filters.noga.coen"), label: translate("benchmarking.evaluations.filters.noga.coen") },
    { id: 711202, value: translate("benchmarking.evaluations.filters.noga.buse"), label: translate("benchmarking.evaluations.filters.noga.buse") },
    { id: 711203, value: translate("benchmarking.evaluations.filters.noga.oten"), label: translate("benchmarking.evaluations.filters.noga.oten") },
    { id: 711204, value: translate("benchmarking.evaluations.filters.noga.lasu"), label: translate("benchmarking.evaluations.filters.noga.lasu") },
    { id: 711205, value: translate("benchmarking.evaluations.filters.noga.otte"), label: translate("benchmarking.evaluations.filters.noga.otte") },
  ];
  return items;
}

export function getRegionsItems(translate) {
  const items = [
    {
      id: 1,
      value: translate("benchmarking.evaluations.filters.regions.RL"),
      label: translate("benchmarking.evaluations.filters.regions.RL"),
      name: "RL",
    },
    {
      id: 2,
      value: translate("benchmarking.evaluations.filters.regions.EM"),
      label: translate("benchmarking.evaluations.filters.regions.EM"),
      name: "EM",
    },
    {
      id: 3,
      value: translate("benchmarking.evaluations.filters.regions.NW"),
      label: translate("benchmarking.evaluations.filters.regions.NW"),
      name: "NW",
    },
    {
      id: 4,
      value: translate("benchmarking.evaluations.filters.regions.ZH"),
      label: translate("benchmarking.evaluations.filters.regions.ZH"),
      name: "ZH",
    },
    {
      id: 5,
      value: translate("benchmarking.evaluations.filters.regions.OS"),
      label: translate("benchmarking.evaluations.filters.regions.OS"),
      name: "OS",
    },
    {
      id: 6,
      value: translate("benchmarking.evaluations.filters.regions.ZS"),
      label: translate("benchmarking.evaluations.filters.regions.ZS"),
      name: "ZS",
    },
    {
      id: 7,
      value: translate("benchmarking.evaluations.filters.regions.TI"),
      label: translate("benchmarking.evaluations.filters.regions.TI"),
      name: "TI",
    },
  ];
  return items;
}

export function getOfficeSizes(translate) {
  const items = [
    {
      id: 1,
      value: `1 - 2 ${translate("benchmarking.evaluations.filters.employees")}`,
      label: `1 - 2 ${translate("benchmarking.evaluations.filters.employees")}`,
      name:"1 - 2"
    },
    {
      id: 2,
      value: `3 - 8 ${translate("benchmarking.evaluations.filters.employees")}`,
      label: `3 - 8 ${translate("benchmarking.evaluations.filters.employees")}`,
      name:"3 - 8"
    },
    {
      id: 3,
      value: `9 - 17 ${translate("benchmarking.evaluations.filters.employees")}`,
      label: `9 - 17 ${translate("benchmarking.evaluations.filters.employees")}`,
      name:"9 - 17"
    },
    {
      id: 4,
      value: `18 - 30 ${translate("benchmarking.evaluations.filters.employees")}`,
      label: `18 - 30 ${translate("benchmarking.evaluations.filters.employees")}`,
      name:"18 - 30"
    },
    {
      id: 5,
      value: `31 - 49 ${translate("benchmarking.evaluations.filters.employees")}`,
      label: `31 - 49 ${translate("benchmarking.evaluations.filters.employees")}`,
      name:"31 - 49"
    },
    {
      id: 6,
      value: `50 - 250 ${translate("benchmarking.evaluations.filters.employees")}`,
      label: `50 - 250 ${translate("benchmarking.evaluations.filters.employees")}`,
      name:"50 - 250"
    },
    {
      id: 7,
      value: `${translate("benchmarking.evaluations.filters.officeSize.above")} 250 ${translate("benchmarking.evaluations.filters.employees")}`,
      label: `${translate("benchmarking.evaluations.filters.officeSize.above")} 250 ${translate("benchmarking.evaluations.filters.employees")}`,
      name:"> 250"
    },
  ];
  return items;
}

export function getSharedFilters(translate) {
  const filters = {
    nogaCode: getNogaItems(translate),
    greaterRegion: getRegionsItems(translate),
    officeSize: getOfficeSizes(translate),
  };
  return filters;
}
